import React from 'react'
import { Paper, Avatar, Typography, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { LockOutlined as LockIcon } from '@material-ui/icons'
import { useMutation } from '@apollo/react-hooks'
import { inject } from 'mobx-react'
import { RouteComponentProps, Redirect } from 'react-router-dom'

import { LOGIN_MUTATION } from '../../graphql/queries/auth'
import { ILoginData, ILoginVariables } from '../../graphql/types/auth'
import { AuthStore } from '../../stores/AuthStore'
import { LoginForm, ILoginFormValues } from './components/LoginForm'
import { Alert } from '@material-ui/lab'

interface IProps {
  authStore: AuthStore
}

const Login: React.FC<IProps & RouteComponentProps> = ({ authStore, history }) => {
  const classes = useStyles()
  const [loading, setLoading] = React.useState<boolean>(false)
  const [error, setError] = React.useState<string>()
  const [login] = useMutation<ILoginData, ILoginVariables>(LOGIN_MUTATION)

  const handleSubmit = async (values: ILoginFormValues) => {
    try {
      setLoading(true)

      const { data } = await login({
        variables: {
          phone: values.phone,
          password: values.password,
        },
      })

      const result = data?.loginAdminByPassword

      if (result) {
        authStore.login(result.user, result.token, result.refreshToken)
        history.push('/')
      }
    } catch (error) {
      // TODO: https://github.com/apollographql/apollo-feature-requests/issues/46
      setError(error.message.replace('GraphQL error: ', ''))
      setLoading(false)
    }
  }

  if (authStore.loggedIn) {
    return <Redirect to='/' />
  }

  return (
    <main className={classes.main}>
      <div className={classes.container}>
        <Paper className={classes.paper} elevation={0}>
          <Avatar className={classes.avatar}>
            <LockIcon />
          </Avatar>
          <Typography component='h1' variant='h5'>
            Войти
          </Typography>
          {!!error && (
            <Box my={2} width='100%'>
              <Alert severity='error'>{error}</Alert>
            </Box>
          )}
          <LoginForm loading={loading} onSubmit={handleSubmit} />
        </Paper>
      </div>
    </main>
  )
}

const useStyles = makeStyles(theme => ({
  main: {
    width: '100%',
    height: '100vh',
    display: 'block', // Fix IE 11 issue.
    backgroundColor: theme.palette.grey[100],
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    paddingTop: theme.spacing(5),
    textAlign: 'center',
    [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
}))

export default inject('authStore')(Login)
